export const createStandardHeader = (title: string) => {
  return () => <div className="text-xs font-medium">{title}</div>;
};
